import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";

const HotelPolicies = ({ hotelData }) => {
  const t = useTranslationDetector('hotel');

  const hotelRule = hotelData?.HotelRule || {};
  const descriptions = hotelData?.Descriptions || [];

  // API'den gelen verilerle policies oluştur
  const policies = useMemo(() => {
    const policiesList = [];

    // Giriş/Çıkış saatleri
    if (hotelRule.CheckinTime || hotelRule.CheckoutTime) {
      policiesList.push({
        icon: byPrefixAndName.far['arrow-right-to-arc'],
        label: t('checkinTime'),
        content: hotelRule.CheckinTime || t('notSpecified'),
      });

      policiesList.push({
        icon: byPrefixAndName.far['arrow-left-to-arc'],
        label: t('checkoutTime'),
        content: hotelRule.CheckoutTime || t('notSpecified'),
      });
    }

    // Checkin içeriği
    const checkinDesc = descriptions.find(d => d.Category === 'Checkin')?.Content;
    if (checkinDesc) {
      policiesList.push({
        icon: byPrefixAndName.far['memo'],
        label: t('hotelConditions'),
        content: checkinDesc,
      });
    }

    // Special Instructions
    const specialInstructions = descriptions.find(d => d.Category === 'Special Instructions')?.Content;
    if (specialInstructions) {
      policiesList.push({
        icon: byPrefixAndName.far['circle-info'],
        label: t('accommodationPolicies'),
        content: specialInstructions,
      });
    }

    // Fees Optionals
    const feesOptionals = descriptions.find(d => d.Category === 'Fees Optionals')?.Content;
    if (feesOptionals) {
      policiesList.push({
        icon: byPrefixAndName.far['money-bill'],
        label: t('feesAndPolicies'),
        content: feesOptionals,
      });
    }

    // Eğer hiç policy yoksa default göster
    if (policiesList.length === 0) {
      return [{
        icon: byPrefixAndName.far['memo'],
        label: t('hotelConditions'),
        content: `<p>${t('noHotelConditionsInfo')}</p>`,
      }];
    }

    return policiesList;
  }, [hotelRule, descriptions, t]);

  return (
    <div className="flex flex-col gap-6 md:gap-12">
      <div className="text-xl sm:text-[23px] md:text-[29px]! font-semibold">
        {t('hotelPolicies')}
      </div>

      <div className="flex flex-col p-6 border border-solid border-border rounded-[10px]">
        {policies.map((item, index) => (
          <div className="flex flex-row max-md:flex-wrap items-start gap-6 justify-between py-6 last:pb-0 first:pt-0 border-b border-solid border-border last:border-none" key={index}>
            <div className="flex items-center gap-2 w-min md:w-1/4">
              <FontAwesomeIcon
                icon={item.icon}
                className="w-[22px]! h-[22px]!"
              />

              <span className="font-semibold text-base leading-21 max-md:whitespace-nowrap ">
                {item.label}
              </span>
            </div>
            <div className="text-base leading-21 font-medium [&_p]:mb-4 w-max md:w-3/4 max-md:flex flex-col justify-end [&_ul_li]:mb-4
              [&_ul_li:last-child]:mb-0 [&_ul_li:nth-last-child(-n+3)]:font-normal" dangerouslySetInnerHTML={{ __html: item.content }} />
          </div>
        ))}
      </div>
    </div>
  )
};

export default HotelPolicies;